export default "__VITE_ASSET__9794b4c5__"